import { TextStyle } from '../types/productProps';

const globalStyleClass = (globalStyle: string): string => {
    return globalStyle !== TextStyle.DEFAULT ? globalStyle : '';
};

export default globalStyleClass;
